








# import settings from '@/settings'

export default {
    name: 'salaries_graph'

    props: {
        datas: {
            type: Array
            required: true
        }
        categories: {
            type: Array
            required: true
        }
    }

    watch:
        datas: (value)->
            @salaries_graph_options.series[0].data = value
            # console.log "WATCH SALARIES GRAPH DATAS ", value
        categories: (value)->
            @salaries_graph_options.xAxis.categories = value
            # console.log "WATCH SALARIES GRAPH CATEGORIES ", value

    data: ()->
        self = @
        return {
            salaries_graph_options: {
                title: false,
                yAxis: {
                    title: {
                        text: 'Salaire horaire (€)'
                    }
                },
                xAxis: {
                    categories: @categories,
                },
                legend: false,
                plotOptions: {
                    series: {
                        marker: {
                            lineWidth: 1
                        }
                    }
                },
                tooltip: {
                    formatter: ()->
                        return this.point.category + '<br/>' +
                            '<b>' + this.series.name + ' : ' + this.point.y + '</b>';
                },
                series: [{
                    name: 'Salaire horaire (€)',
                    data: @datas
                }]
            }
        }

    beforeMount: ()->
        @salaries_graph_options.series[0].data = @datas
        @salaries_graph_options.xAxis.categories = @categories
        # console.log "SALARIES GRAPH", @datas, @categories
}

